<div>
	<button class="btn">Add Quick Filter</button>
	<button class="btn" disabled>Clear</button>
</div>